import { objectToSnakeCase, objectToCamelCase } from '../utils'

import api from './api'
import Goal from '../goals'

export default class Project {
  static api = api.create(Project)

  constructor({
    id = null,
    title = '',
    isInactive = null,
    isVerified = null,
    shortDescription = null,
    longDescription = null,
    headline = null,
    impact = null,
    timeline = null,
    maker = null,
    makerRef = null,
    profilePic = null,
    mapPic = null,
    funderCount = null,
    followerCount = null,
    questionerCount = null,
    attributes = [],
    attributesRef = [],
    photos = [],
    mostRecentActiveGoal = null,
    location = null,
    latitude = null,
    longitude = null,
    projectFeed = null,
    uncollectedFunds = null,
    cashOutAllowed = null,
    followedByMe = false,
    ownedByMe = false,
    activatorNotes = '',
    approver = null,
    approverRef = null,
    activator = null,
  } = {}) {
    Object.assign(this, {
      id,
      title,
      isInactive,
      isVerified,
      shortDescription,
      longDescription,
      headline,
      impact,
      timeline,
      maker,
      makerRef,
      profilePic,
      mapPic,
      funderCount,
      followerCount,
      questionerCount,
      attributes,
      attributesRef,
      photos,
      mostRecentActiveGoal: Goal.fromAPI(mostRecentActiveGoal),
      location,
      latitude,
      longitude,
      projectFeed,
      uncollectedFunds,
      cashOutAllowed,
      followedByMe,
      ownedByMe,
      activatorNotes,
      approver,
      approverRef,
      activator,
    })
  }

  copy() {
    return new Project(this)
  }

  update(data = {}) {
    return Object.assign(this.copy(), data)
  }

  static create(data = {}) {
    return new Project(data)
  }

  static fromAPI(json = {}) {
    return new Project(objectToCamelCase(json))
  }

  /**
   *  Prep data for the API.
   **/
  static toAPI(project, fields = []) {
    // By default, send the whole project
    let data = {}

    // If it's a partial update, get only the fields specified
    if (fields.length > 0) {
      fields.forEach(field => {
        data[field] = project[field]
      })
    } else {
      data = project
    }

    return objectToSnakeCase(data)
  }

  static checkIsInstance(obj, name) {
    if (!(obj instanceof Project)) {
      throw Error(`${name} must be an instance of the Project class.`)
    }
  }
}
